import { apiClient } from "@apis/apiClient";

/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  get(id: any) {
    return apiClient.get(`/rest/notification_message/${id}`);
  },

  getFromDate(fromDate: any) {
    return apiClient.get(
      `/rest/notification_message/notification?fromDate=${encodeURIComponent(
        fromDate
      )}`
    );
  },

  makeAsRead(params: any) {
    return apiClient.put(
      `/rest/notification_message/update/hasRead/by/notificationids`,
      params
    );
  },

  create(params: any) {
    return apiClient.post(`/rest/notification_message`, params);
  },

  update(id: any, params: any) {
    return apiClient.put(`/rest/notification_message/${id}`, params);
  },

  delete(id: any) {
    return apiClient.delete(`/rest/notification_message/${id}`);
  },

  getCloneInfo(id: any) {
    return apiClient.get(`/rest/notification_message/clone/${id}`);
  },
};
